__turbopack_context__.v({
  "embeddedForm": "_5pgNeG_embeddedForm",
  "faqVariant": "_5pgNeG_faqVariant",
});
